module.exports = "/_next/static/resources/nami-wide-0fd9615427ffd011b49e469da90010bb.png";